import { useCallback } from 'react';
import { IOS, ANDROID, HUAWEI, PAGE_LOADED_EVENT } from '../utils/constants';

const iOSPageLoaded = (payload = {}) => {
  if (window.webkit && window.webkit.messageHandlers) {
    window.webkit.messageHandlers.ListenEventsInterface.postMessage({
      event: PAGE_LOADED_EVENT,
      payload,
    });
  }
};

const androidPageLoaded = (payload = {}) => {
  if (window.GenericLandingEvents) {
    window.GenericLandingEvents.sendEvents(
      JSON.stringify({
        event: PAGE_LOADED_EVENT,
        payload,
      }),
    );
  }
};

const defaultFunction = () => {
  console.log('Page Loaded event triggered (Default)');
};

const OS_PAGE_LOADED_FUNCTIONS = {
  [IOS]: (payload) => iOSPageLoaded(payload),
  [ANDROID]: (payload) => androidPageLoaded(payload),
  [HUAWEI]: (payload) => androidPageLoaded(payload),
};

const usePageLoaded = (platform) => {
  const sendPageLoaded = useCallback(
    (payload = {}) => {
      const fn = OS_PAGE_LOADED_FUNCTIONS[platform] || defaultFunction;
      fn(payload);
    },
    [platform],
  );

  return {
    sendPageLoaded,
  };
};

export default usePageLoaded;
